module.exports = __webpack_public_path__ + "static/img/Start.59f7f69.png";